import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { chatApi as n } from "@maat/api-chat";
//#region src/hooks/useInboxConversationLookup.ts
var r = (r, i, a) => t({
	queryKey: e.inboxLookup(a ? `${i}:${a}` : i),
	queryFn: () => n.lookupInboxConversation({
		reference_type: r,
		reference_id: i,
		...a && { guest_user_id: a }
	}),
	enabled: !!i
});
//#endregion
export { r as useInboxConversationLookup };
